export const formatDate = (pdate: Date, format: string): string => {
  if (!format) format = "DD/MM/YYYY HH:MM";
  if (typeof pdate === "number") pdate = new Date(+pdate);

  const d = new Date(pdate);
  let date = "";

  if (format === "DD/MM") {
    date += ("0" + d.getDate()).slice(-2) + "/";
    date += ("0" + (d.getMonth() + 1)).slice(-2);
  }

  if (format === "MM/YYYY") {
    date += ("0" + (d.getMonth() + 1)).slice(-2) + "/";
    date += d.getFullYear();
  }

  if (format === "DD/MM/YYYY") {
    date += ("0" + d.getDate()).slice(-2) + "/";
    date += ("0" + (d.getMonth() + 1)).slice(-2) + "/";
    date += d.getFullYear();
  }

  if (format === "MM-DD-YYYY") {
    date += ("0" + (d.getMonth() + 1)).slice(-2) + "-";
    date += ("0" + d.getDate()).slice(-2) + "-";
    date += d.getFullYear();
  }

  if (format === "DD-MM-YYYY") {
    date += ("0" + d.getDate()).slice(-2) + "-";
    date += ("0" + (d.getMonth() + 1)).slice(-2) + "-";
    date += d.getFullYear();
  }

  if (format === "YYYY-MM-DD") {
    date += d.getFullYear() + "-";
    date += ("0" + (d.getMonth() + 1)).slice(-2) + "-";
    date += ("0" + d.getDate()).slice(-2);
  }

  if (format === "YYYY-MM-DD-HH:MM") {
    date += d.getFullYear() + " ";
    date += ("0" + (d.getMonth() + 1)).slice(-2) + "-";
    date += ("0" + d.getDate()).slice(-2) + "-";
    date += ("0" + d.getHours()).slice(-2) + ":";
    date += ("0" + d.getMinutes()).slice(-2);
  }

  if (format === "DD/MM/YYYY HH:MM") {
    date += ("0" + d.getDate()).slice(-2) + "/";
    date += ("0" + (d.getMonth() + 1)).slice(-2) + "/";
    date += d.getFullYear() + " ";
    date += ("0" + d.getHours()).slice(-2) + ":";
    date += ("0" + d.getMinutes()).slice(-2);
  }

  if (format === "DD/MM/YYYY HH:MM local") {
    date += ("0" + d.getDate()).slice(-2) + "/";
    date += ("0" + (d.getMonth() + 1)).slice(-2) + "/";
    date += d.getFullYear() + " ";
    date += d.toLocaleTimeString();
  }

  if (format === "HH:MM") {
    date += ("0" + d.getHours()).slice(-2) + ":";
    date += ("0" + d.getMinutes()).slice(-2);
  }

  if (format === "YYYY,MM,DD") {
    date += d.getFullYear();
    date += ("0" + (d.getMonth() + 1)).slice(-2) + ",";
    date += ("0" + d.getDate()).slice(-2) + ",";
  }

  return date;
};